import { api } from '../utils/api';

class DiagnosticService {
  private static isLoggingError = false;

  public static async logEvent(data: {
    component: string;
    error: string;
    context?: Record<string, any>;
    level?: 'error' | 'warning' | 'info';
  }): Promise<boolean> {
    if (this.isLoggingError) return false;

    try {
      const { component, error, context = {}, level = 'error' } = data;
      const formattedError = level === 'error'
        ? `[CRITICAL] ${error}`
        : level === 'warning'
        ? `[WARNING] ${error}`
        : `[INFO] ${error}`;

      this.isLoggingError = true;

      const response = await api.post('/api/auth/diagnostics', {
        component,
        error: formattedError,
        context: {
          ...context,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        },
        timestamp: new Date().toISOString()
      });

      return response.success || false;
    } catch {
      return false;
    } finally {
      this.isLoggingError = false;
    }
  }

  public static async logTurnstileIssue(errorType: string, details: Record<string, any> = {}): Promise<boolean> {
    return this.logEvent({
      component: 'TurnstileWidget',
      error: `Turnstile ${errorType}`,
      context: { ...details, turnstileAvailable: !!window.turnstile }
    });
  }

  public static async logNetworkError(endpoint: string, error: any, context: Record<string, any> = {}): Promise<boolean> {
    return this.logEvent({
      component: 'NetworkRequest',
      error: `API Error: ${endpoint}`,
      context: {
        ...context,
        endpoint,
        errorMessage: error instanceof Error ? error.message : String(error),
      }
    });
  }
}

export default DiagnosticService;
